<template>
  <div class="-mt-10">
    <div class="text-top">
      <div class="content">
        <i class="icon icon-bor-notice" />
        <p>【重要なお知らせ】お知らせテキスト</p>
      </div>
    </div>

    <div class="menu-top" v-show="loggedIn">
      <div class="user">
        <div class="user-info flex">
          <div class="name-user pt-3">
            <div class="user-name text-black" v-if="infoCustomer && infoCustomer.username">{{ infoCustomer.username }} 様</div>
          </div>
          <div class="id-user pt-3 md:hidden">
            <div v-if="infoCustomer && infoCustomer.userId" class="user-id member">会員ID: {{ infoCustomer.memberNo }}</div>
          </div>
        </div>
        <!-- <a-divider type="vertical" class="md:hidden" /> -->
        <div class="point flex">
          <div @click="gotoPath()" class="pl-10">
            <a><img src="~@/assets/icons/benepo-icon.png" /></a>
          </div>
          <div @click="gotoPath()">
              <a class="text-black"><span v-if="infoCustomer && infoCustomer.point">{{ infoCustomer.point | formatInteger }}ポイント</span></a>
              <i class="icon icon-bor-arrow-right"></i>
          </div>
        </div>
        <!-- <a-divider type="vertical" class="md:hidden"/> -->
      </div>
      <div class="select-menu">
        <ItemTop />
      </div>
    </div>

    <div class="l-container confirm-info mx-auto">
      <div class="main-content">
        <div class="service">
          <h1>ライフサービス</h1>
          <a-divider type="vertical" />
          <div class="service-item">
            <p>旅行・宿泊</p>
            <i class="icon icon-bor-copy" />
          </div>
          <a-divider type="vertical" />
          <div class="service-item">
            <p>ベネ通販</p>
            <i class="icon icon-bor-copy" />
          </div>
        </div>
        <div class="menu-search c-box">
          <div class="menu-tabs">
            <MenuNavigation :data="meneNavigationData" @selectedCategory="selectedCategorySearch" />
          </div>
          <div class="search-tabs">
            <div class="search-input">
              <a-input
                placeholder="施設名、メニューNo、地名などを入力（例：大阪出張）"
                size="large"
                @input="input"
              />
              <a-button size="large" @click="onSearch()">
                <i class="icon icon-bor-search" />
                <span class="sm:hidden">検索</span>
              </a-button>
            </div>
            <div class="checkbox">
              <a-checkbox-group>
                <a-row>
                  <a-col>
                    <a-checkbox
                      v-for="item in checkboxData"
                      :key="item"
                      :value="{ item }"
                    >
                      {{ item }}
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </div>
            <div class="tags">
              <div class="tag-item">
                <p class="sm:hidden">人気キーワード</p>
                <a-tag v-for="item in tagsData" :key="item" color="#EDEEF0">
                  {{ item }}
                </a-tag>
              </div>
              <a-divider />
              <div class="collapse">
                <p>地図検索</p>
                <i class="icon icon-bor-triangle-down"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="c-box p-4 center-content">
        <div class="content">
          <SectionContentTitle
            class="mt-4"
            lineType="h-line"
            titleContent="給トク払いが利用できるおすすめのセット"
          />
          <span style="font-size: 16px"
            >ベネフィット・ステーションに給与天引きで利用できるメニューが登場！是非ご利用いただきたいメニューをセットでご紹介します。</span
          >

          <div class="relax grid">
            <div class="relax-skills">
              <div class="relax-items">
                <p class="font-bold">リラックス&スキルアップセット</p>
                <span
                  >有休が貯まっているあなたにおすすめ。温泉でリラックスしながら、旅のおともにこちらの本でスキルアップ。</span
                >
              </div>
              <div class="skills-item gap-4">
                <Item
                  v-for="(item, index) in imageRelax"
                  :key="index"
                  type="hidden"
                  :src="item.img"
                  :classItem="styleRelax"
                />
              </div>
            </div>

            <div class="relax-skills mt-4 p-6">
              <div class="relax-items">
                <p class="font-bold">お得に情報通セット</p>
                <span
                  >毎月の定額利用も給与天引きならさらにお得に。あなたの専門分野の定期購読誌をピックアップしてみました。</span
                >
              </div>
              <div class="skills-item gap-4 mt-2">
                <Item
                  v-for="(item, index) in imageInfo"
                  :key="index"
                  type="hidden"
                  :src="item.img"
                  :classItem="styleInfo"

                />
              </div>
            </div>
          </div>

          <div class="flex justify-end">
            <Navigate
              text="給トク払いについて詳しくはこちら"
              :type_arrow="icon"
            />
          </div>

          <div class="mt-16">
            <SectionContentTitle
              lineType="h-line"
              titleContent="あなたにおすすめのメニュー"
            />
            <div class="item-image justify-between gap-4">
              <Item
                v-for="(item, index) in imageRanking"
                :key="index"
                type=""
                :src="item.img"
              />
            </div>
          </div>

          <div class="mt-12">
            <section class="p-0">
              <SectionContentTitle
                lineType="h-line"
                titleContent="特集・イベント"
              />
              <CarouselEvents :img="imageCarousel" />
            </section>
            <div class="flex justify-end mt-4">
              <Navigate text="特集・イベントの一覧を見る" :type_arrow="icon" />
            </div>
          </div>

          <div class="mt-16">
            <SectionContentTitle
              lineType="h-line"
              titleContent="アクセスランキング"
            />
            <div class="mb-4 tabs-ranking">
              <a href="#">旅</a>
              <a-divider type="vertical" />
              <a href="#">食べる</a>
              <a-divider type="vertical" />
              <a href="#">遊ぶ</a>
              <a-divider type="vertical" />
              <a href="#">買い物</a>
              <a-divider type="vertical" />
              <a href="#">育児・介護・健康</a>
              <a-divider type="vertical" />
              <a href="#">その他</a>
            </div>
            <div class="item-image-scroll">
              <Item
                v-for="(item, index) in imageRanking"
                :key="index"
                type="hidden"
                :src="item.img"
                :classItem="styleRanking"
              />
            </div>
          </div>

          <div class="mt-8">
            <SectionContentTitle
              lineType="h-line"
              titleContent="ベネフィットステーションの便利なサービス・制度"
            />
            <div class="relax-skills-item justify-between mb-4">
              <img
                v-for="(item, index) in imageService"
                :key="index"
                class="img-sigle"
                :src="item.img"
              />
            </div>

            <div class="flex justify-end">
              <Navigate text="サービス・制度の一覧を見る" :type_arrow="icon" />
            </div>
          </div>

          <div class="mt-16">
            <SectionContentTitle
              lineType="h-line"
              titleContent="最近チェックしたメニュー"
            />
            <div class="item-image-scroll">
              <Item
                v-for="(item, index) in imageRanking"
                :key="index"
                type="hidden"
                :src="item.img"
              />
            </div>
            <div class="flex justify-end">
              <Navigate text="閲覧履歴を見る" :type_arrow="icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-container confirm-info mx-auto">
      <div class="my-16">
        <SectionContentTitle
          lineType="h-line"
          titleContent="ベネフィット・ステーションのSNS公式アカウント"
        />
        <span
          >会員の皆様にベネフィット・ステーションの最新情報やおすすめの特典情報をお届けします！</span
        >
        <div class="social-item mt-2">
          <SocialItem
            :social_data="social_data"
            v-for="(social_data, index) in social_data"
            :key="index"
          />
        </div>
      </div>
    </div>

    <div class="catalog c-box p-4 mb-8">
      <div class="catalog-content">
        <div>
          <SectionContentTitle
            lineType="h-line"
            titleContent="デジタルカタログ・会報誌"
          />
          <div class="flex station sm:grid sm:gap-4">
            <div class="img">
              <img class="img-ver" src="@/assets/images/digital3.png" />
            </div>
            <div class="description">
              <div class="title-ben">BENEFIT STATION通信 2021 Spring</div>
              <span
                >ベネフィット・ステーションの最新情報・おすすめ情報などをご紹介しています。<br />下のボタンからオンラインでご覧いただけます。<br />書籍でのご購入、お申込みは各メニューページよりご確認ご利用ください。</span
              >
              <div class="mt-4">
                <div class="flex gap-3 mb-3 ">
                  <a-button>全国版</a-button>
                  <a-button>北海道・東北版</a-button>
                  <a-button>中部版</a-button>
                </div>
                <div class="flex gap-3">
                  <a-button>近畿版</a-button>
                  <a-button>中国・四国版</a-button>
                  <a-button>九州・沖縄版</a-button>
                </div>
              </div>
            </div>
            <div class="flex items-end md:justify-end pb-4">
              <Navigate text="バックナンバーを見る" :type_arrow="icon" />
            </div>
          </div>
          <div class="img-bottom justify-between mt-6">
            <div>
              <img class="img-mid" src="@/assets/images/digital2.png" />
            </div>
            <div>
              <img class="img-mid" src="@/assets/images/digital1.png" />
            </div>
          </div>
        </div>
        <div class="mt-16">
          <SectionContentTitle lineType="h-line" titleContent="お知らせ" />
          <div class="flex gap-3">
            <span> 2021.00.00 </span>
            <span>システムメンテナンスに伴うサービス停止のご案内</span>
          </div>
          <div class="flex gap-3">
            <span> 2021.00.00 </span>
            <span>掲載店舗の営業時間について</span>
          </div>
          <div class="flex gap-3">
            <span> 2021.00.00 </span>
            <span
              >Famiポートシステムメンテナンスに伴うシステムサービス停止のお知らせ</span
            >
          </div>
          <div class="flex justify-end my-4">
            <Navigate text="お知らせ一覧を見る" :type_arrow="icon" />
          </div>
        </div>
        <div>
          <div class="img-bottom justify-between">
            <div>
              <img class="img-mid" src="@/assets/images/notify2.png" />
            </div>
            <div>
              <img class="img-mid" src="@/assets/images/notify3.png" />
            </div>
          </div>
          <img class="w-full h-32 mt-4" src="@/assets/images/notify1.png" />
        </div>
      </div>
      <InstructionLogin3 :visible="popupLogin" @ok="popupLogin = false" @cancel="popupLogin = false"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  Navigate,
  SectionContentTitle,
  CarouselEvents
} from '@/components/compound'

import Item from './components/Item'
import SocialItem from './components/SocialItem'
import ItemTop from './components/ItemTop'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import MenuNavigation from './components/MenuNavigation'

export default {
  name: 'BS_TOP_01_001',
  components: {
    Item,
    Navigate,
    SectionContentTitle,
    CarouselEvents,
    SocialItem,
    ItemTop,
    MenuNavigation
  },
  data() {
    return {
      form: {
        keyword: '',
        category: ''
      },
      icon: 'icon-bor-arrow-right',
      popupLogin: false,
      infoUser: {
        username: 'ベネフィット 太郎 様',
        id: '会員ID：xxxxx@aaaaa.com',
        pointNum: 1500
      },
      checkboxData: [
        '給トク払いが使える',
        '会員証またはクーポン呈示での利用',
        'ベネポが使える',
        'ベネポが貯まる'
      ],
      tagsData: ['遊園地', 'ディズニー', '出張', '映画', 'クリスマス'],
      imageRanking: [
        { img: require('@/assets/images/ranking1.png') },
        { img: require('@/assets/images/ranking2.png') },
        { img: require('@/assets/images/ranking3.png') },
        { img: require('@/assets/images/ranking4.png') },
        { img: require('@/assets/images/ranking5.png') }
      ],
      styleRanking: 'style-ranking',
      imageService: [
        { img: require('@/assets/images/service4.png') },
        { img: require('@/assets/images/service5.png') },
        { img: require('@/assets/images/service3.png') },
        { img: require('@/assets/images/service3.png') },
        { img: require('@/assets/images/service4.png') },
        { img: require('@/assets/images/service5.png') }
      ],
      imageRelax: [
        { img: require('@/assets/images/relax1.png') },
        { img: require('@/assets/images/relax2.png') }
      ],
      styleRelax: 'style-relax',
      imageInfo: [
        { img: require('@/assets/images/info1.png') },
        { img: require('@/assets/images/info2.png') }
      ],
      styleInfo: 'style-Info',
      imageCarousel: [
        { img: require('@/assets/images/banner1.png') },
        { img: require('@/assets/images/banner2.png') },
        { img: require('@/assets/images/banner3.png') },
        { img: require('@/assets/images/banner2.png') },
        { img: require('@/assets/images/banner1.png') }
      ],
      meneNavigationData: [
        {
          first: true,
          icon: 'icon icon-bor-9-menu',
          labelDesktop: 'すべて',
          labelMobile: 'すべて',
          active: true
        },
        {
          icon: 'icon icon-bor-3-star',
          labelDesktop: '旅',
          labelMobile: '旅',
          active: false
        },
        {
          icon: 'icon icon-bor-dish',
          labelDesktop: '食べる',
          labelMobile: '食べる',
          active: false
        },
        {
          icon: 'icon icon-bor-3-star',
          labelDesktop: '遊ぶ',
          labelMobile: '遊ぶ',
          active: false
        },
        {
          icon: 'icon icon-bor-book',
          labelDesktop: '買い物',
          labelMobile: '買い物',
          active: false
        },
        {
          icon: 'icon icon-bor-heart-on-hand',
          labelDesktop: '育児・介護・健康',
          labelMobile: '育児・介護・健康',
          active: false
        },
        {
          icon: 'icon icon-bor-3-dot',
          labelDesktop: 'その他',
          labelMobile: 'その他',
          active: false,
          last: true
        }
      ],
      social_data: [
        {
          icon: 'icon-bor-twitter',
          name: '公式Twitter',
          text: '最新＆おすすめの特典情報をお届けします！'
        },
        {
          icon: 'icon-bor-facebook',
          name: '公式Facebook',
          text: '最新＆おすすめの特典情報をお届けします！'
        },
        {
          icon: 'icon-bor-line',
          name: '公式Instagram',
          text: '（インスタの紹介テキストが入ります）'
        },
        {
          icon: 'icon icon-bor-tiktok-black',
          name: '公式Tiktok',
          text: 'ダンサーによるチャレンジ動画など、楽しい動画をご覧いただけます！（仮）'
        },
        {
          icon: 'icon icon-bor-youtube-black',
          name: '公式YouTube',
          text: 'ベネフィット・ステーションの使い方など、サービスに関する動画を配信中です。（仮）'
        }
      ]
    }
  },
  mounted() {
    const router = this.$route.query
    if (+router.loggin === 1) {
      this.popupLogin = true
    }
    this.$store.dispatch(BREADCRUMBS, [])
  },
  computed: {
    infoCustomer() {
      return _.get(this.$store.getters, 'bs_app.info_user', null)
    },
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  watch: {
    infoCustomer(val) {
      console.log('val', val)
    }
  },
  methods: {
    gotoPath() {
      this.$router.push({path: '/mypage/benepo-history'})
    },
    selectedCategorySearch($event) {
      this.form.category = $event
    },
    input(e) {
      // console.log(e.target.value)
      this.form.keyword = e.target.value
    },
    onSearch() {
      // console.log(this.form.keyword)
      if (!this.form.keyword) {
        return
      }
      this.$router.push({
        path: '/search/menu',
        query: this.getQueryString()
      })
    },
    getQueryString() {
      // this.$page.isPageHeader = false
      const result = {}
      if (this.form.keyword) {
        result.keyword = this.form.keyword
        result.category = this.form.category ? this.form.category : 'すべて'
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.user {
  .ant-divider,
  .ant-divider-vertical {
    height: 48px;
  }
}
.service {
  .ant-divider,
  .ant-divider-vertical {
    @apply mx-8;
    height: 24px;
    @media (max-width: 768px) {
      @apply mx-3;
      height: 18px;
    }
  }
}
.search-tabs {
  .ant-checkbox-wrapper {
    @media (max-width: 768px) {
      @apply ml-0;
    }
  }
  .tags {
    .ant-divider {
      @apply hidden;
      @media (max-width: 768px) {
        @apply block;
      }
    }
  }
  .ant-tag {
    color: #1f2021;
    font-size: 14px;
    padding: 8px;
    @media (max-width: 768px) {
      font-size: 12px;
      margin-right: 4px;
    }
  }
}
.search-input {
  .ant-input {
    background-color: #edeef0;
    border-radius: 8px 0 0 8px;
    border: none;
  }
  .ant-btn {
    background-color: #1f2021;
    color: #dcdee0;
    border-radius: 0px 8px 8px 0px;
    border: none;

    span {
      @apply ml-4;
      font-size: 14px;
    }
  }
}
.description {
  .ant-btn {
    font-size: 12px;
    height: 45px;
    width: 130px;
    padding: 0;
    @media only screen and (max-width: 768px) {
      height: 45px;
      width: 105px;
    }
  }
}
</style>
